import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Row } from 'rsuite';

const Title = (props:{isGoBackLinkVisible : any, setGoBackLinkValue: any, powerBiSelectedCustomer: any}) => {
    const navigate = useNavigate();
    const {isGoBackLinkVisible, setGoBackLinkValue, powerBiSelectedCustomer} = props;

   const goBack = () => {
        setGoBackLinkValue(false)
        
        navigate("/customer-profitability?customerId=" + powerBiSelectedCustomer);
    }
return (
        <Row className="show-grid brandTitle">
            <Col xs={24} sm={24} md={24} >
                <div className="text-center upload-title" style={{color: '#ffffff', padding : '0px'}}>Cross-Sell
                    {isGoBackLinkVisible === true && <span onClick={() => goBack()} className="goBack" style={{paddingRight: '2%'}}>
                        <i className="fa fa-arrow-left" aria-hidden="true"></i>
                            Go back
                    </span>}
                </div>
            </Col>
        </Row>
);

}

export default Title;